<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <mat-drawer-container class="flex-auto h-full">

        <!-- Drawer -->
        <mat-drawer
            #matDrawer
            [autoFocus]="false"
            [mode]="'side'"
            [opened]="true"
            class="w-72 dark:bg-gray-900">
            <!-- Demo sidebar -->
            <table-sidebar></table-sidebar>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">

            <!-- Main -->
            <div class="flex-auto p-6 sm:p-10">

                <!-- Drawer toggle -->
                <!--                <button-->
                <!--                    (click)="matDrawer.toggle()"-->
                <!--                    class="mb-4"-->
                <!--                    mat-icon-button>-->
                <!--                    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>-->
                <!--                </button>-->

                <ng-content select="[breadcrumbs]"></ng-content>
                <ng-content select="[heading]"></ng-content>

                <!-- CONTENT GOES HERE -->
                <div>
                    <ng-content select="[content]"></ng-content>
                </div>

            </div>

        </mat-drawer-content>

    </mat-drawer-container>

</div>
